import {Outlet, useLocation} from "react-router-dom";
import React, {useEffect} from "react";
import styled from "styled-components";
import Header from "../components/organisms/Header";
import Footer from "../components/organisms/Footer";
import GuideHead from "../components/atoms/GuideHead";
import DStoryHead from "../components/molecules/DStoryHead";
import {device} from "../assets/styles/media";
import {useMediaQuery} from "react-responsive";
import SubNav2 from "../components/molecules/SubNav2";


const Wrap = styled.div`
    position: relative;
    width: 100%;
    min-height: 100%;
    box-sizing: border-box;
    top: 0;
    overflow: hidden;
    ${device.tablet} {
        position: relative;
        min-height: 100%;
    }
`;
const ContentWrap = styled.div`
    padding-top: 80px;
    width: 100%;
    height: 100%;

    ${device.tablet} {
        top: 100%;
        width: 100%;
        padding-top: 50px;
    }
    ${device.mobile} {
        top: 100%;
        padding-top: 58px;
    }
`;
const ContainerInner = styled.div`
    max-width: 1540px;
    margin: 0 auto;
    padding: 0 50px;
    box-sizing: border-box;
    
    ${device.mobile} {
        max-width: 100vw;
        padding: 0 20px;
    }

`;
const TabPadding = styled.div`
    ${device.tablet} {
        max-width: 100%;
        margin-top: 50px;
    }
`;
const PagePadding = styled.div`
    margin-top: 120px;
    ${device.tablet} {
        margin-top: 230px;
    }
    ${device.mobile}{
        margin-top: 100px;
    }
`;

const ScrollToTop = () => {
    const location = useLocation();
    useEffect(() => {
        if (location.hash) {
            const id = location.hash.replace("#", "");
            const element = document.getElementById(id);
            if (element) {
                element.scrollIntoView({behavior: "smooth"});
            }
        } else {
            window.scrollTo(0, 0);
        }
    }, [location]);

    return null;
};



const Layouts = () => {
    const isTablet = useMediaQuery({ maxWidth: 1023 });
    const {pathname} = useLocation();

    const isHome = pathname === "/";
    const renderHeader = () => {
        if (pathname.startsWith("/program") || pathname.startsWith("/notice")) {
            return <DStoryHead/>;
        } else if (pathname.startsWith("/guide")) {
            return <GuideHead/>;
        }
        return null;
    };

    //subNav2 사용여부
    const showSubNav2 = pathname.startsWith('/map/');

    return (
        <Wrap>
                <Header isTablet={isTablet}/>
                {isHome ? (<Outlet/>)
                    :
                    <ContentWrap>
                        {renderHeader()} {/* 조건부 헤더 렌더링 */}
                        {isTablet && pathname.startsWith("/program") ||
                        isTablet && pathname.startsWith("/notice") ? (
                            <TabPadding/>
                        ) : null}
                        <ContainerInner>
                            <ScrollToTop/>
                            {showSubNav2 && <><SubNav2 /> <PagePadding/></>  }
                            <Outlet/>
                        </ContainerInner>
                    </ContentWrap>
                }
                <Footer/>
        </Wrap>
    );
};


export default Layouts;
